import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink, Route } from 'react-router-dom';
import { ListItem, Tooltipped } from 'react-md';

import CustomMenuIcon from '../CustomMenuIcon';

const NavLink = ({ label, to, exact, icon, search }) => (
  <Route path={to} exact={exact}>
    {({ match }) => {
      let leftIcon;
      if (icon) {
        leftIcon = <CustomMenuIcon name={icon} alt={label} />;
      }

      return (
        <Tooltipped key={`internal-nav-item-tooltip-${to}`} label={label} position="right">
          <ListItem
            component={RouterLink}
            active={!!match}
            to={to}
            search={search}
            primaryText={label}
            leftIcon={leftIcon}
          />
        </Tooltipped>
      );
    }}
  </Route>
);

NavLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  search: PropTypes.string,
};

NavLink.defaultProps = {
  search: '',
};

export default NavLink;
